import { render, staticRenderFns } from "./CustomVehicleIcon.vue?vue&type=template&id=bd114a56&scoped=true&"
import script from "./CustomVehicleIcon.vue?vue&type=script&lang=ts&"
export * from "./CustomVehicleIcon.vue?vue&type=script&lang=ts&"
import style0 from "./CustomVehicleIcon.vue?vue&type=style&index=0&id=bd114a56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd114a56",
  null
  
)

export default component.exports